
export const isDuplicateKeyError = (error: any): boolean => {
  if (!error) return false;
  
  const errorMessage = error.message || "";
  const errorCode = error.code || "";
  
  return (
    errorCode === "23505" ||
    errorMessage.includes("duplicate key value") ||
    errorMessage.includes("unique constraint") ||
    errorMessage.includes("violates unique constraint")
  );
};

export const extractFieldFromError = (error: any): string | null => {
  if (!error) return null;
  
  const errorMessage = error.message || "";
  
  const constraintMatch = errorMessage.match(/constraint\s+"([^"]+)"/);
  if (constraintMatch) {
    const constraintName = constraintMatch[1]; // e.g., "airport_services_service_code_key"
    const parts = constraintName.split("_");
    
    if (parts.length >= 3 && parts[parts.length - 1] === "key") {
      return parts[parts.length - 3] + "_" + parts[parts.length - 2];
    } else if (parts.length === 2 && parts[1] === "key") {
      return parts[0];
    }
  }
  
  const keyMatch = errorMessage.match(/(\w+)_key/);
  if (keyMatch) {
    const fullMatch = keyMatch[0];
    const parts = fullMatch.split("_");
    if (parts.length >= 3) {
      return parts[parts.length - 3] + "_" + parts[parts.length - 2];
    } else if (parts.length === 2) {
      return parts[0];
    }
  }
  
  return null;
};

export const getDuplicateKeyErrorMessage = (error: any, fieldName?: string): string => {
  const extractedField = extractFieldFromError(error) || fieldName;
  
  if (extractedField) {
    const fieldLabels: Record<string, string> = {
      service_code: "Service Code",
      tour_code: "Tour Code",
      transfer_code: "Transfer Code",
      attraction_code: "Attraction Code",
    };
    
    const label = fieldLabels[extractedField] || extractedField;
    return `A ${label.toLowerCase()} with this value already exists. Please use a different ${label.toLowerCase()}.`;
  }
  
  return "This value already exists. Please use a different value.";
};

export const formatErrorMessage = (error: any, defaultMessage: string = "An error occurred"): string => {
  if (!error) return defaultMessage;
  
  if (isDuplicateKeyError(error)) {
    return getDuplicateKeyErrorMessage(error);
  }
  
  const errorMessage = error.message || defaultMessage;
  
  if (errorMessage.includes("violates") || errorMessage.includes("constraint")) {
    return "This operation cannot be completed. Please check your input and try again.";
  }
  
  return errorMessage;
};
